module.exports = __webpack_public_path__ + "static/media/404.61c5b202.png";